import { types } from './clevertap.meta';

const SEARCH_INIT = 'aa_htl_search_inititated';
const SELECT_HOTEL = 'aa_htl_hotelselect_actions';
const SELECT_ROOM = 'aa_htl_roomselect_actions';
const GUEST_DETAIL_SUBMIT = 'aa_htl_guestdetails_submitted';
const PAYMENT_SUCCESS = 'aa_htl_booking_successful';

const recordCleverEvent = (evt, data) => {
  return {
    event: evt,
    data: data,
  };
};

export const cleverAnalyticsEvents = {
  [types.HOTEL_SEARCH_INIT_CLEAVER]: ({ payload }) =>
    recordCleverEvent(SEARCH_INIT, payload),
  [types.HOTEL_SELECT_HOTEL_CLEVER]: ({ payload }) =>
    recordCleverEvent(SELECT_HOTEL, payload),
  [types.HOTEL_SELECT_ROOM_CLERVER]: ({ payload }) =>
    recordCleverEvent(SELECT_ROOM, payload),
  [types.HOTEL_GUEST_DETAIL_SUBMIT_CLEVER]: ({ payload }) =>
    recordCleverEvent(GUEST_DETAIL_SUBMIT, payload),
  [types.HOTEL_PAYMENT_SUCCESS_CLEVER]: ({ payload }) =>
    recordCleverEvent(PAYMENT_SUCCESS, payload),
};
